export const truncateToMaxBytes = (str: string, maxBytes: number = 150): string => {
    const encoder = new TextEncoder();
    const bytes = encoder.encode(str);

    if (bytes.length <= maxBytes) {
        return str;
    }

    // String kürzen - wir müssen vorsichtig sein wegen Multi-Byte-Zeichen
    let truncated = str;
    let currentBytes = bytes.length;

    // Iterativ kürzen bis wir unter dem Limit sind (inkl. "...")
    while (currentBytes > maxBytes - 3) { // -3 für "..."
        truncated = truncated.slice(0, -1);
        currentBytes = encoder.encode(truncated).length;
    }

    return truncated + '...';
}

export const toYearMonthDayTrackingString = (item : string) : string => {

    if(item === 'flexible') {
        return'egal';
    }

    if(item === 'later') {
        return 'spaeter';
    }

    const year = item.slice(0, 4);
    let month = item.slice(4, 6);

    let day = '';
    if(item.length > 6) {
        day = `${item.slice(6,8)}-`;
    }

    return `${day}${month}-${year}`;
}

